import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  distance: 0,
  remainingTime: "",
  isTimer : false,
};

export const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    updateTimer: (state, action) => {
      state.distance = action.payload.distance;
      state.remainingTime = action.payload.remainingTime;
      state.isTimer = true;
    },
    resetTimer: (state) => {
      state.distance = 0;
      state.remainingTime = "";
      state.isTimer = false;
    },
    setTimer: (state) => {
      state.isTimer = true;
    },
  },
});

export const { updateTimer, resetTimer, setTimer } = timerSlice.actions;

export default timerSlice.reducer;
